export const contactPreferredFields = [
  'cEmailAddress',
  'addressType',
  'physicalAddress',
  'postalAddress',
  'mPhoneNumber',
  'hPhoneNumber',
  'oPhoneNumber',
];
